export default {
  // 'SET_SPORTS_LIST' (state, data) {
  //   state.sports = {
  //     url: 'sports',
  //     ...data
  //   }
  // },
  // 'SET_COUNTRIES_LIST' (state, data) {
  //   state.countries = {
  //     url: 'countries',
  //     ...data
  //   }
  // },
  // 'SET_GENDERS_LIST' (state, data) {
  //   state.genders = {
  //     url: 'genders',
  //     ...data
  //   }
  // },
  // 'SET_AGES_LIST' (state, data) {
  //   state.ages = {
  //     url: 'ages',
  //     ...data
  //   }
  // },
  // 'SET_PARTNERS_LIST' (state, data) {
  //   state.partners = {
  //     url: 'partners',
  //     ...data
  //   }
  // },
  // 'SET_ROLES_LIST' (state, data) {
  //   state.roles = {
  //     url: 'roles',
  //     ...data
  //   }
  // },
  'SET_REASONS_LIST' (state, data) {
    state.reasons = {
      url: 'reasons',
      ...data
    }
  },
  'SET_ABILITIES_LIST' (state, data) {
    state.abilities = {
      url: 'abilities',
      ...data
    }
  },
  'SET_WATERMARKS_LIST' (state, data) {
    state.watermarks = {
      url: 'watermarks',
      ...data
    }
  },
  'SET_SOURCES_LIST' (state, data) {
    state.sources = {
      url: 'sources',
      ...data
    }
  },
  'SET_RESTREAMERS_SERVERS_LIST' (state, data) {
    state.restreamersServers = {
      url: 'restreamers/servers',
      ...data
    }
  },
  'SET_BELLS_LIST' (state, data) {
    state.bells = {
      url: 'bells',
      ...data
    }
  },
  'UPDATE_BELLS_LIST' (state, data) {
    state.bells = { ...state.bells, data: [...state.bells.data, ...data.data] }
  }
}
